import advisorProfiles from './advisorProfiles'
import organizationCompanies from './organizationCompanies'
import organizations from './organizations'
import organizationUsers from './organizationUsers'
import userProfiles from './userProfiles'
import users from './users'

const backoffice = {
  advisorProfiles,
  organizationCompanies,
  organizations,
  organizationUsers,
  userProfiles,
  users,
}

export default backoffice
